import React from 'react';
import ReactDOM from 'react-dom';
import { Amplify } from 'aws-amplify';

import { amplifyV6Config } from './amplify-v6-config';
import configureServices from './configure-services';
import { sendBridgeLinkOpened } from './core/helpers/bridge-link-opened';
import { reloadOnStaleChunk } from './core/helpers/stale-chunk-reload';
import './core/styles.css';
import App from './core/components/app';
import { installContextualToolsShortcut, isContextualToolsPreview } from './tools/contextual-prototype/preview-context';
import { installPreviewReadOnlyNetwork } from './tools/contextual-prototype/read-only';

installContextualToolsShortcut();
if (isContextualToolsPreview()) {
  installPreviewReadOnlyNetwork();
}

Amplify.configure(amplifyV6Config);
configureServices();
sendBridgeLinkOpened();
reloadOnStaleChunk();

// Legacy root on purpose: keeps React 17 sync-render semantics for MobX/Formik (no createRoot yet).
ReactDOM.render(<App />, document.getElementById('root'));
